import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import {
  downloadQRCode,
  generateQRCode,
  type QRCodeResult,
} from '../../../../shared/lib/qr-generator'

interface LinkDetailQrProps {
  shortUrl: string
  shortCode: string
}

const QR_SIZE = 160

/**
 * 상세 패널의 QR.
 * 생성이 비동기라 패널에서 떼어내 실패해도 패널 전체가 흔들리지 않게 한다.
 */
export default function LinkDetailQr({
  shortUrl,
  shortCode,
}: LinkDetailQrProps) {
  const { t } = useTranslation()
  const [qr, setQr] = useState<QRCodeResult | null>(null)

  useEffect(() => {
    let cancelled = false
    setQr(null)

    generateQRCode(shortUrl, { size: QR_SIZE })
      .then(result => {
        if (!cancelled) {
          setQr(result)
        }
      })
      .catch(error => {
        // QR 은 부가 정보다. 실패해도 나머지는 그대로 쓸 수 있어야 한다.
        console.error('QR 생성 실패:', error)
      })

    return () => {
      cancelled = true
    }
  }, [shortUrl])

  return (
    <div className="flex w-[120px] shrink-0 flex-col items-center gap-1.5 rounded-xl border border-gray-100 p-2.5 dark:border-gray-700">
      <div className="grid h-24 w-24 place-items-center">
        {qr && (
          <img
            src={qr.dataUrl}
            alt={t('bookmark.detail.qrAlt', { code: shortCode })}
            width={96}
            height={96}
            className="h-24 w-24"
          />
        )}
      </div>
      <button
        type="button"
        disabled={!qr}
        onClick={() => qr && downloadQRCode(qr, `${shortCode}.${qr.format}`)}
        className="flex items-center gap-1 text-[11px] font-semibold text-primary-600 transition hover:text-primary-700 disabled:opacity-40"
      >
        <ArrowDownTrayIcon className="h-3.5 w-3.5" />
        {t('bookmark.detail.saveQr')}
      </button>
    </div>
  )
}
